import productConfig from "emun.products/product.config";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import ProductParser from "emun.products/parser/product-parser";
import ProductImport from "emun.products/picker/product-picker-import-items";
import "emun.products/picker/product-picker-list.htm";
import "emun.products/picker/product-picker-table.htm";
import "emun.products/picker/product-picker-grid.htm";
import "emun.products/picker/product-picker-cards.htm";
import ApplyTagsPrompt from "emun.products/lists/apply-tags-prompt";
import shoppingConfig from "emun.shopping/shopping.config";
import modals from "webmodals/modals";

export const views = {
  list: "th-list",
  table: "table",
  cards: "th-large",
};

export default class ProductPickerController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    //console.debug("ProductPickerController", { $ctrl, options });
    $ctrl.setProductIds();
    $ctrl.images = [];
    $ctrl.totalSelectedDollars = 0;
    const aqArgs = {
      url: `QueryProducts.json?JsConfig=ExcludeDefaultValues`, //&Fields=${options.fields}
      tagTotalsUrl: `QueryProductTagTotals.json?Take=500&ProductIdsToTake=0&JsConfig=ExcludeDefaultValues`,
      ...productConfig,
      pageSize: 12,
      criteria: {
        ...options.criteria,
      },
      orderBy: shoppingConfig.orderBy,
      //fields: 'ProductTemplateId,OnDemandProductId,OnDemandProductLabel,ProductTemplateLabel,Ratio,Height,Width,Depth,Weight,Images,Areas,Active,Id,ManufacturerNumber,ShortDescription,LongDescription,Status,Pricing,ListPrice,WholesalePrice,RetailPrice,RetailListPrice,Price,MinimumOrderQty,AvailableQty,IncomingQty,PurchaseIncrement,OptionGroup,VendorId,IsB2B,IsB2C,IsSellable,ItemType,Keywords,SuperCategory,Tags,IsNew,IsRestricted,Meta,IsOnDemand,CreatedOn,Cost,Featured,Likes,HasLiked,ProductImages',
      sortOptions: shoppingConfig.sortOptions,
      views,
      view: options.view || ($ctrl.$pageConfig.is("gt-md") ? "table" : "cards"),
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: false,
      append: false,
      scrub(response) {
        response.data.results = Product.map(response.data.results);
      },
      afterLoaded(args) {
        $ctrl.setProductIds();
        args.results.forEach(function (arg) {
          $ctrl.images.push({
            thumbUrl: arg.getImageUrl("large"),
            url: arg.getImageUrl("large"),
          });
        });
      },
    };
    $ctrl.query = new AutoQuery(aqArgs);
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.viewSelectionsChanged(); //load()
  }

  templateUrl = () => `product-picker-${this.query.view}.htm`;

  selectAllVisible() {
    const $ctrl = this;
    $ctrl.query.results.forEach((p) => ($ctrl.selected[p.id] = true));
    this.setProductIds();
  }
  selectAll() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", `Select ${$ctrl.query.total} items`)
      .result.then(function () {
        const request = {
          ...$ctrl.query.getRequest(true),
          tagCriteria: $ctrl.query.getTagCriteria(),
          take: 50000,
          skip: 0,
          Fields: "Id",
          include: false,
          includePricing: false,
        };
        return $ctrl.bus
          .read("QueryProducts.json?op=SelectAll", request)
          .then(({ data }) => {
            data.results.forEach((p) => ($ctrl.selected[p.id] = true));
            $ctrl.setProductIds();
          });
      });
  }
  clearAll() {
    this.selected = {};
    this.setProductIds();
  }
  canClear() {
    return Object.keys(this.selected).length;
  }

  isSelected(product) {
    return !!this.selected[product.id];
  }

  setProductIds() {
    this.productIds = Object.keys(this.selected || {});
  }

  selectionsLabel() {
    const { productIds: keys = [] } = this;
    if (keys.length > 4)
      return `Selected: ${keys.slice(0, 4).join(", ")} and ${
        keys.length - 4
      } more...`;
    if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
    return "No selections";
  }

  hasSelections = () => Object.keys(this.selected).length > 0;

  viewSelectionsChanged() {
    const $ctrl = this;
    const idIn = $ctrl.viewSelections
      ? Object.keys($ctrl.selected || {}).join(",")
      : null;
    $ctrl.query.clearRefinements(false);
    return $ctrl.query.filter("IdIn", idIn);
  }

  toggle(product) {
    const $ctrl = this;
    //console.log("toggle", product.id, $ctrl.selected, product);
    if ($ctrl.single) {
      $ctrl.onProductSelected &&
        $ctrl.onProductSelected({ $product: product, ...$ctrl });
      $ctrl.$close(product);
    } else if (product.id in $ctrl.selected) {
      delete $ctrl.selected[product.id];
      $ctrl.totalSelectedDollars -= product.price;
      $ctrl.onProductUnSelected &&
        $ctrl.onProductUnSelected({ $product: product, ...$ctrl });
    } else {
      if ($ctrl.dollarsAllowed > 0) {
        if ($ctrl.totalSelectedDollars + product.price > $ctrl.dollarsAllowed) {
          modals.alert("Not enough remaining dollars to spend");
          return;
        }
      }
      $ctrl.totalSelectedDollars += product.price;
      $ctrl.selected[product.id] = true;
      $ctrl.onProductSelected &&
        $ctrl.onProductSelected({ $product: product, ...$ctrl });
    }
    this.setProductIds();
  }

  select(product) {
    const $ctrl = this;
    $ctrl.onProductSelected &&
      $ctrl.onProductSelected({ $product: product, ...$ctrl });
    $ctrl.$close($ctrl.single ? product : [product]);
  }

  $onDestroy() {
    this.query.dispose();
  }
  parseProducts() {
    const $ctrl = this;
    return ProductParser({ returnProducts: true }).then((products) => {
      $ctrl.selected = {};
      //console.debug("parseProducts", products);
      products.forEach((p) => $ctrl.toggle(p));
      $ctrl.viewSelections = true;
      return $ctrl.viewSelectionsChanged();
    });
  }
  importProducts() {
    const $ctrl = this;
    return ProductImport({
      size: "xl",
    }).then((products) => {
      $ctrl.selected = {};
      //console.debug("parseProducts", products);
      products.forEach((p) => $ctrl.toggle(p));
      $ctrl.viewSelections = true;
      return $ctrl.viewSelectionsChanged();
    });
  }
  applyTags() {
    const $ctrl = this;
    return ApplyTagsPrompt({
      productIds: $ctrl.productIds,
      title: `Apply Tags...`,
    });
  }
  toggleInactive() {
    const $ctrl = this;
    if ($ctrl.showInactive) {
      $ctrl.showInactive = false;
      $ctrl.query.criteria.status = "Active";
    } else {
      $ctrl.showInactive = true;
      $ctrl.query.criteria.status = "";
      $ctrl.query.criteria.IncludeInactive = true;
    }
    $ctrl.query.load(true);
  }
}
